import React from 'react';
import styled from 'styled-components';

const StoreBlock = styled.div`
  box-sizing: border-box;
  width: 100%;
  flex: 0 0 25%;
  max-width: 25%;
  padding: 0 5px 0;
  cursor: pointer;

  a {
    text-decoration: none;
  }

  img {
    width: 100%;
    height: auto;
    padding-bottom: 1.25rem;
  }

  h5 {
    padding-bottom: 0.75rem;
    font-size: 1.125rem;
    font-weight: 500;
    color: #1b1b1b;
    vertical-align: middle;

    small {
      font-size: 0.75rem;
      color: #767676;
    }
  }

  p {
    color: #333333;
  }

  @media screen and (max-width: 499px) {
    flex: 0 0 33.333%;
    max-width: 33.333%;
    padding: 0 4px 0;
    img {
      width: 100%;
      height: auto;
      padding-bottom: 0.75rem;
    }
    h5 {
      padding-bottom: 0;
      font-size: 0.875rem;
      small {
        padding-top: 0.5rem;
        display: block;
      }
    }

    p {
      display: none;
    }
  }
`;

const StoreItem = ({ props }) => {
  const { image, name, place, product, url } = props;
  return (
    <StoreBlock>
      <a href={`https://${url}`} target="_blank" rel="noopener noreferrer">
        <img src={image} alt="store" />
        <h5>
          {name} <small>{place}</small>
        </h5>
        <p>{product}</p>
      </a>
    </StoreBlock>
  );
};

export default StoreItem;
